/**
 * @copyright 2026 Cooltrax Pty Ltd. All rights reserved.
 *
 * The two screens the cold storage page serves. Blast Freezer is cold storage narrowed
 * to the Freezer asset type, with a column for how long each sensor has been in range.
 * Each is its own app grant (coldStorage, blastFreezer — MEGA-827), named by its mode,
 * and keeps its own session state and query cache.
 */

import { ALERT_WIDTH, DEFAULT_LIST_WIDTH, MIN_LIST_WIDTH, TIMING_WIDTH } from './columns'

export type ColdStorageMode = 'coldStorage' | 'blastFreezer'

export interface ModeConfig {
  mode: ColdStorageMode
  /** The app's name, for the page's title bar while the nav is collapsed. */
  title: string
  /** Prefix of the page's sessionStorage keys. */
  sessionPrefix: string
  /** The state endpoint the list and floor plan poll. */
  statePath: string
  stateQueryKey: string
  /** Show each sensor's time in range (or estimated time to it). */
  showTiming: boolean
  defaultListWidth: number
  minListWidth: number
  emptyText: string
}

export const MODES: Record<ColdStorageMode, ModeConfig> = {
  coldStorage: {
    mode: 'coldStorage',
    title: 'Cold Storage',
    sessionPrefix: 'coldStorage',
    statePath: '/fresh/in-store/state',
    stateQueryKey: 'cold-storage-state',
    showTiming: false,
    defaultListWidth: DEFAULT_LIST_WIDTH + ALERT_WIDTH,
    minListWidth: MIN_LIST_WIDTH + ALERT_WIDTH,
    emptyText: 'No in-store assets.',
  },
  blastFreezer: {
    mode: 'blastFreezer',
    title: 'Blast Freezer',
    sessionPrefix: 'blastFreezer',
    statePath: '/fresh/in-store/blast/state',
    stateQueryKey: 'blast-freezer-state',
    showTiming: true,
    defaultListWidth: DEFAULT_LIST_WIDTH + ALERT_WIDTH + TIMING_WIDTH,
    minListWidth: MIN_LIST_WIDTH + ALERT_WIDTH + TIMING_WIDTH,
    emptyText: 'No freezers.',
  },
}
